import { useState, useEffect } from 'react';
import { fetchSignedImageUrl } from '../store/drone_slice';

// Simple cache to avoid redundant API calls
const urlCache: Record<string, string> = {};

export const useSignedUrl = (imageKey: string | undefined): string => {
  const [signedUrl, setSignedUrl] = useState<string>('');

  useEffect(() => {
    const getSignedUrl = async () => {
      // If no key or empty key, return empty string
      if (!imageKey || imageKey.trim() === '') {
        setSignedUrl('');
        return;
      }

      // If it's a blob URL or placeholder, use it directly
      if (imageKey.startsWith('blob:') || imageKey.includes('placeholder')) {
        setSignedUrl(imageKey);
        return;
      }

      // Check cache first
      if (urlCache[imageKey]) {
        setSignedUrl(urlCache[imageKey]);
        return;
      }

      // If it already looks like a full URL, use it directly
      if (imageKey.startsWith('http')) {
        setSignedUrl(imageKey);
        return;
      }

      // Check if it looks like an S3 key (contains path separators)
      try {
        const url = await fetchSignedImageUrl(imageKey);
        
        // Update cache and state
        if (url) {
          urlCache[imageKey] = url;
          setSignedUrl(url);
        } else {
          setSignedUrl(''); // Don't use the key as fallback
        }
      } catch {
        setSignedUrl(''); // Don't use the key as fallback
      }
    };

    getSignedUrl();
  }, [imageKey]);

  return signedUrl;
}; 